import { ESRI_DEFAULT_ICON_LABEL_FONT } from '../configurations';
import type { LabelClassProperties } from '../types';
import { colors } from '../../colors/colors';
import cameraLive from '../images/camera-icons/camera_live.svg';
import cameraOffline from '../images/camera-icons/camera_offline.svg';
import { CAMERA_ICON_NAMES } from '../../sensors/helpers';

const [LIVE_ICON_NAME, OFFLINE_ICON_NAME] = CAMERA_ICON_NAMES;

/**
 * Keyed on the camera's own status rather than a selection state: camera detail lives in a
 * workspace panel, not the map ledger, so there is no map-level selection to reflect.
 *
 * The values come from `CAMERA_ICON_NAMES` so they cannot drift from `getCameraIconName`, which is
 * what actually stamps `iconName` onto each graphic. A mismatch renders the grey default symbol.
 */
export const cameraUniqueValueInfos = [
    {
        value: LIVE_ICON_NAME,
        symbol: {
            type: 'picture-marker',
            url: cameraLive,
            width: '32px',
            height: '32px',
        },
    },
    {
        value: OFFLINE_ICON_NAME,
        symbol: {
            type: 'picture-marker',
            url: cameraOffline,
            width: '32px',
            height: '32px',
        },
    },
];

export const cameraIconRenderer = {
    type: 'unique-value', // autocasts as new UniqueValueRenderer()
    field: 'iconName',
    defaultSymbol: {
        // used when iconName does not match anything defined in uniqueValueInfos
        type: 'simple-marker',
        style: 'square',
        color: colors.mapLabelDefault,
        size: '32px',
    },
    uniqueValueInfos: [...cameraUniqueValueInfos],
    authoringInfo: undefined,
};

const cameraIconLabel: LabelClassProperties = {
    symbol: {
        type: 'text',
        color: colors.mapLabelText,
        haloColor: colors.mapLabelHalo,
        haloSize: '1px',
        xoffset: '-4px',
        font: ESRI_DEFAULT_ICON_LABEL_FONT,
    },
    labelPlacement: 'center-right',
    labelExpressionInfo: {
        expression: `$feature.sensorName`,
    },
    maxScale: 0,
    // Only label once zoomed in reasonably far; a dense camera install would otherwise bury the map.
    minScale: 50000,
};

export const cameraIconLabels = [cameraIconLabel];
